import axios from "axios";

axios.defaults.baseURL =
  process.env.VUE_APP_BASE_PRODUCTSDB_BACK_URL || "http://143.198.248.102/";

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.headers.common["Authorization"] =
  "Bearer " + localStorage.getItem("token");

export const apiGet = async (url, headers = {}) => {
  let instance = axios.create({
    headers,
  });
  return await instance.get(url);
};
export const apiPost = async (url, body, headers = {}) => {
  let instance = axios.create({
    headers,
  });
  return await instance.post(url, body);
};
export const apiDelete = async (url, headers = {}) => {
  let instance = axios.create({
    headers,
  });
  return await instance.delete(url);
};
export const apiUpdate = async (url, body, headers = {}) => {
  let instance = axios.create({
    headers,
  });
  return await instance.put(url, body);
};
